import React, { useState } from "react";
import { Col, Divider, Row, Tabs } from "antd";

import CustomSelect from "../CustomFormItem/Select";
import ListRecettes from "./ListRecettes";
import ListDepenses from "./ListDepenses";
import useRentalIncomeExpense from "../../hooks/useRentalIncomeExpense";


const ListRevenusFonciers = (props) => {

  const [key, setKey] = useState("1");

  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const { years, incomes, expenses, loading} = useRentalIncomeExpense(selectedYear);

  const handleYearChange = (value) => {
    setSelectedYear(parseInt(value));
  };

  return (
    <div style={{ padding: 20 }}>
        <Row gutter={12}>
          <Col span={5}>
            <CustomSelect
              label={"Année"}
              defaultValue={selectedYear}
              objectValue={selectedYear}
              style={{textAlign: 'left', width: 120}}
              onChange={handleYearChange}
              options={years.map(year => ({value: Number(year), label: year.toString()}))}
            />
          </Col>
        </Row>
      <Divider />
      <Tabs
        defaultActiveKey="1"
        activeKey={key}
        onChange={(key) => setKey(key)}
        items={[
          {
            label: "Recettes",
            key: "1",
            children: (
              <ListRecettes
                loading={loading}
                incomes={incomes}
              />
            ),
          },
          {
            label: "Dépenses",
            key: "2",
            children: (
              <ListDepenses
                loading={loading}
                expenses={expenses}
              />
            ),
          },
        ]}
      />
    </div>
  );
};

export default ListRevenusFonciers;
